// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"268":"00546665","462":"2266d920"}[chunkId] + ".chunk.js";
};